import { RootState } from '../../../app';

export const selectNavigationHandlers = ({ navigation }: RootState) =>
  navigation.handlers;

export const selectIsModalOpened = ({ navigation }: RootState) =>
  navigation.isModalOpened;
